import { jsx as _jsx } from "react/jsx-runtime";
import createSvgIcon from "./utils/createSvgIcon";
export default createSvgIcon([
    /*#__PURE__*/ _jsx("path", {
        fill: "currentColor",
        d: "m12.0001 6 4 6 5-4-2 10h-14L3 8l5 4z"
    }, "0"),
    /*#__PURE__*/ _jsx("path", {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M12.0001 5a1 1 0 0 1 .832.4453l3.395 5.0925 4.1483-3.3187a.9999.9999 0 0 1 1.6052.977l-2 10a1 1 0 0 1-.9805.8039h-14a1 1 0 0 1-.9806-.8039l-2-10a1 1 0 0 1 1.6053-.977l4.1482 3.3187 3.395-5.0925A1 1 0 0 1 12.0001 5m0 2.8028-3.168 4.7519a1 1 0 0 1-1.4567.2262L4.519 10.4958 5.82 17h12.3604l1.3008-6.5042-2.8564 2.2851a1 1 0 0 1-1.4567-.2262z",
        clipRule: "evenodd"
    }, "1")
], "Crown", {
    "style": {
        "fill": "none"
    },
    "viewBox": "0 0 24 24"
});
